export const CONVERSATION_FUNC = 'getConversationById';
export const CONVERSATION_GET_MESSAGES_FUNC = 'getMessages';

// a.k.a. - limit
export const MESSAGES_PER_PAGE = 10;
